export const AUTH_STORAGE_KEYS = {
    accessToken: 'access_token',
    accessTokenTimestamp: 'access_token_timestamp',
    user: 'user',
    organizations: 'organizations',
    access: 'access',
    impersonatorAccessToken: 'impersonator_access_token',
    selectedOrganization: 'selected-organization',
    selectedBranch: 'selected-branch',
    appConfig: 'app-config',
    impersonatorSelectedOrganization: 'impersonator_selected_organization',
    impersonatorSelectedBranch: 'impersonator_selected_branch',
    lastPayload: 'last_payload'
} as const;
